import { render } from "./MenuM.vue?vue&type=template&id=00319dec&scoped=true"
import script from "./MenuM.vue?vue&type=script&lang=js"
export * from "./MenuM.vue?vue&type=script&lang=js"

import "./MenuM.vue?vue&type=style&index=0&id=00319dec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00319dec"]])

export default __exports__